import script from "./CertificationComplete.vue?vue&type=script&setup=true&lang=js"
export * from "./CertificationComplete.vue?vue&type=script&setup=true&lang=js"

import "./CertificationComplete.vue?vue&type=style&index=0&id=3361950e&scoped=true&lang=css"

import exportComponent from "/home/jenkins/storybird-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3361950e"]])

export default __exports__